import * as React from 'react';
import * as _ from 'lodash'
import { useImmer } from 'use-immer';
import CheckBoxList, { ItemCheckbox } from '../../../../components/CheckBoxList';
import { JobWorkerT } from '../../../../types/JobWorker';
import Permissions from '../../../../utils/Permissions';
import { copyObject } from '../../../../utils';
import { OptionsPermissions } from '../OptionsFieldsJob';

export type ICrewCrewPermissionsProps = {
    worker: JobWorkerT
    index?: number
    updateWorker(key: string, value: any): void
}

const CrewPermissions: React.FC<ICrewCrewPermissionsProps> = ({ worker, updateWorker, index }) => {
    // const [optionsData, setOptionsData] = React.useState([]);
    const [dirtyPermissions, setdirtyPermissions] = React.useState([]);
    const [state, setState] = useImmer({
        optionsData: []
    });

    React.useEffect(() => {
        let workerPermissions = worker.permissions ? worker.permissions : []
        if (!_.isEqual(workerPermissions, dirtyPermissions)) {
            setdirtyPermissions(workerPermissions)
        }
        const listCheckbox = prepareListCheckbox(OptionsPermissions, workerPermissions)
        setState((draft) => {
            // draft.concat(getOptionsData(OptionsPermissions))
            draft.optionsData = listCheckbox
        })
    }, [worker.permissions]);

    /**
     * 
     * @param listPermissions 
     * @param workerPermissions 
     * @return Array<ItemCheckbox>
     */
    const prepareListCheckbox = (listPermissions, workerPermissions: Array<string>): Array<ItemCheckbox> => {
        let salesIsChecked = false;
        return Object.keys(listPermissions).map((key, index) => {
            let isChecked = workerPermissions.includes(key) ? true : false
            let disabled = false
            if (key == "sales" && isChecked == true) {
                salesIsChecked = true
            }
            if (key == "address" && salesIsChecked == true) {
                isChecked = true
                disabled = true
            }
            return {
                value: key,
                label: OptionsPermissions[key],
                checked: isChecked,
                disabled: disabled
            }
        })
    }

    /**
     * 
     * @param value 
     * @param checked 
     */
    const onCheckBoxPress = (value: string, checked: boolean) => {
        const index = state.optionsData.findIndex((x) => x.value == value)
        if (index != -1 && state.optionsData[index]) {
            setState((draft) => {
                draft.optionsData[index].checked = checked
            })
        }

        // if (value == "sales" && checked==true) {
        //     salesIsChecked = true
        // }

        const perInstance = new Permissions(copyObject(worker.permissions))
        if (checked) {
            perInstance.add(value)
        } else {
            perInstance.remove(value)
        }

        updateWorker("permissions", copyObject(perInstance.getPermissions()));
    }


    return (
        <div className="mt-2 mb-2">
            <h5>Permissions</h5>
            <CheckBoxList data={state.optionsData} onCheckBoxPress={onCheckBoxPress} inline={true} />
        </div>
    );
}
export default CrewPermissions;
export { CrewPermissions };